import { render, staticRenderFns } from "./sumprint.vue?vue&type=template&id=036ff19e&scoped=true&"
import script from "./sumprint.vue?vue&type=script&lang=js&"
export * from "./sumprint.vue?vue&type=script&lang=js&"
import style0 from "./sumprint.vue?vue&type=style&index=0&id=036ff19e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ff19e",
  null
  
)

export default component.exports